import { render, staticRenderFns } from "./DashboardLegalEntity.vue?vue&type=template&id=e44d2dba&"
import script from "./DashboardLegalEntity.vue?vue&type=script&lang=js&"
export * from "./DashboardLegalEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports